import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
import _ from 'lodash';
// import { getPersistItem } from '../utils/etc'

const getUserType = (token) => {
  let userType = ''
  try {
    if (token) {
      let user = JSON.parse(window.atob(localStorage.getItem('x-auth-token').split('.')[1]))
      userType = user?.user_type?.toLowerCase()
    }
  }
  catch (err) {
    console.log(`error parsing token ${token} err: ${err}`)
  }
  return userType
}

const slice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('x-auth-token'),
    loginError: false,
    passwordError: '',
    redirectToLogin: false,
    userType: getUserType(localStorage.getItem('x-auth-token'))
  },
  reducers: {
    loginFailed: (state, action) => {
      state.loginError = true
    },

    loggedIn: (state, action) => {
      state.loginError = false;
      state.token = localStorage.getItem('x-auth-token');
      state.userType = getUserType(localStorage.getItem('x-auth-token'))
    },

    logout: (state) => {
      localStorage.removeItem('x-auth-token');
      state.userType = ''
      state.token = false;
    },

    passwordResetSuccess: (state, action) => {
      if (action.payload) state.redirectToLogin = true;
    },

    passwordResetFailed: (state) => {
      state.passwordError = 'Something went wrong, please try again.'
    }
  }
})

const { loginFailed, loggedIn, passwordResetFailed, passwordResetSuccess } = slice.actions
export const {  logout } = slice.actions;
export default slice.reducer;

export const login = (email, password) => (dispatch, getState) => {
  const url = `/auth`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: { email, password },
      onSuccess: loggedIn.type,
      onError: loginFailed.type
    })
  );
}

export const forgotPassword = (email) => (dispatch, getState) => {
  const url = `/auth/forgot-password`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {email: email},
    })
  );
}

export const changeForgottonPassword = (payload) => (dispatch) => {
  const url = `/auth/change-forgotton-password`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: payload,
      onSuccess: passwordResetSuccess.type,
      onError: passwordResetFailed.type
    })
  );
}